import styled from 'styled-components'

export const Container = styled.div`  
  position:relative;
  display:flex;
  flex-flow:column noWrap;
  flex:1;
  height:100vh;
  box-sizing: border-box;  
  background-color:tomato;
  justify-content:space-between;
  align-items:row;
  --background-image: url('image/fundoTela01.jpg');
  background-position: center center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #1594a5; 
  overflow:hidden;  
`
export const Title = styled.span`
  display:flex;
  flex-flow: row wrap;
  width:100%;
  color: #FFF;
  margin-bottom:4px; 
`
export const ContainerNome = styled.div`
  display:flex;
  flex-flow: row wrap;
  font-size: 13px;
  color: #FFF;
  margin-bottom:1px; 
  margin-top: 10px;
`
export const ContainerImage = styled.div`
  display:flex;  
  top:0px;
  width:100%;
  height:80px;
  justify-content:center;
  align-items:center;  

  @media (min-width: 800px) 
  {
    height:160px;
  } 

  @media (min-width: 700px) 
  {
    height:150px;
  } 
`

export const Image = styled.img`
  width: 40%;

  @media (min-width: 800px) 
  {
    width: 30%;
  } 
`
export const HeaderTitle = styled.span`
  margin-top: -70px;
  font-size: 15px;
  color: #FFF;
  text-align: center;
`
export const ContainerField = styled.div`
  margin-top: 10px;
  width: 100%;
`

export const SubContainerButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
export const ContainerContentHorarios = styled.div`
  display:flex;
  flex-direction: column;
  justify-content:space-between;
  align-items:center;
  
  margin:3px;
  margin-top: 10px;
  color: #FFF;
  font-size: 20px;
`
export const DivHorario = styled.div`
  color: ${(props) => props.acao ? '#8ced9c' : '#FFF'};
  display:flex;
  flex-direction: row;
  justify-content:space-between;
  align-items:center;
  width: 100%;
`
export const Body = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px 40px;
`
export const ContainerEndereco = styled.div`
  color: #fff;
  margin: 80px 40px 0 40px;
  position: absolute;
  font-size: 15px;
 
  
 
`

export const StyledEndereco = styled.div`
  margin-top: 10px;
  color: ${(props) => props.color ? props.color: '#FFF'};
  text-align: center;
  
`
export const StyledUni = styled.div`
  color: #000;
`
export const ContainerImgClock = styled.div`
  position: absolute;
  top: 66px;
  right: -19px;
  margin-top: -43px;
  width: 100px;
  
`

